import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const UsersDataSlice = createSlice({
    name: "Users",
    initialState,
    reducers: {
        getUsersRequest(state) {
            state.loading = true;
        },
        getUsersRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getUsersRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getUsersRequest,
    getUsersRequestSuccess,
    getUsersRequestError,
} = UsersDataSlice.actions;

export default UsersDataSlice.reducer;
